import { ToolImplementation, ToolResult, ToolSchema } from '../tool-types';
import { getCurrentCupraStateId } from '@/config/cupra-conversation-states';

export const advisorToolCupraSchema: ToolSchema = {
  type: 'function',
  name: 'get_cupra_recommendation',
  description:
    'Get a structured CUPRA model recommendation based on user needs. Use this after 2-3 discovery turns.',
  parameters: {
    type: 'object',
    properties: {
      user_needs: {
        type: 'string',
        description: 'Compact summary of user preferences and constraints from needs discovery'
      }
    },
    required: ['user_needs'],
    additionalProperties: false
  }
};

export const advisorToolCupraImplementation: ToolImplementation = async (
  args: any
): Promise<ToolResult> => {
  try {
    const userNeeds = typeof args?.user_needs === 'string' ? args.user_needs.trim() : '';
    if (!userNeeds) {
      return {
        success: false,
        error: 'Invalid user_needs parameter. Expected a non-empty string.'
      };
    }

    const baseUrl = ''; // Azure Functions are same-origin under the web app API
    const response = await fetch(`${baseUrl}/api/cupra/recommendation`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_needs: userNeeds,
        stateId: getCurrentCupraStateId()
      })
    });

    if (!response.ok) {
      const details = await response.text();
      return {
        success: false,
        error: details || 'CUPRA recommendation API request failed.'
      };
    }

    const payload = await response.json();
    const recommendation = payload?.recommendation;
    if (!recommendation) {
      return {
        success: false,
        error: 'CUPRA recommendation API returned no recommendation.'
      };
    }

    return {
      success: true,
      data: recommendation
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error in CUPRA advisor tool'
    };
  }
};

